import { Constructor } from '@angular/cdk/table';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { LanguageService } from 'src/app/content-management/shared/services/language.service';
import { ILanguage } from 'src/app/core/models/i-language';

type WithLanguagesFormSectionType = {
  languages$: Observable<ILanguage[]>;
  _initLanguages(getPreviousSelectedValue: () => string | null): void;
  _initLanguageValueChanges(
    getPreviousSelectedValue: () => string | null,
  ): void;
  _buildLanguage(): string;
  get language(): string;
  DEFAULT_LANGUAGE_OPTION: string;
};

type WithLanguagesFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { LANGUAGE: () => string };
  destroy$: Subject<boolean>;
  languageService: LanguageService;
  formBuilder: FormBuilder;
};

export function WithLanguagesFormSection<
  TBase extends Constructor<WithLanguagesFormSectionRequerimentsBase>,
>(
  baseClass: TBase,
): {
  new (...args: any[]): WithLanguagesFormSectionType;
  prototype: WithLanguagesFormSectionType;
} & TBase {
  return class LanguagesFormSectionable extends baseClass {
    languages$!: Observable<ILanguage[]>;
    readonly DEFAULT_LANGUAGE_OPTION = 'none';

    constructor(...args: any[]) {
      super(...args);
    }

    _initLanguages(getPreviousSelectedValue: () => string | null): void {      
      this.languages$ = this.languageService.getAll$().pipe(
        tap((languages: ILanguage[]) => {
          this.form.get(this.FORM_PATHS.LANGUAGE()).setValue(
            languages.find(
              // TODO REFACTOR: This should be code, not Code
              // tslint:disable-next-line:no-string-literal
              (l) => l.Code === getPreviousSelectedValue()
            ) ?? this.DEFAULT_LANGUAGE_OPTION
          );
        }),
      );
    }

    _initLanguageValueChanges(
      getPreviousSelectedValue: () => string | null,
    ): void {
      this.form
        .get(this.FORM_PATHS.LANGUAGE())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (
              newValue?.Code === getPreviousSelectedValue() ||
              (newValue === this.DEFAULT_LANGUAGE_OPTION &&
                !getPreviousSelectedValue())
            ) {
              this.form.get(this.FORM_PATHS.LANGUAGE()).markAsPristine();
            }
          },
        });
    }

    _buildLanguage(): string {
      return this.form.get(this.FORM_PATHS.LANGUAGE()).value?.Code;
    }

    get language(): string {
      return `Language ${
        this.form.get(this.FORM_PATHS.LANGUAGE()).value?.FriendlyName
          ? `(${this.form.get(this.FORM_PATHS.LANGUAGE()).value?.FriendlyName})`
          : ''
      }`;
    }
  };
}
